import { Vector3 as o } from "three";
import { V3toVector3 as a } from "../index9.js";
import { applyTransform as n } from "./index2.js";
function y(r, t) {
  let p = Array.isArray(r) ? new o(...r) : r;
  for (; t.parent; )
    p = a(n(p, t.parent)), t = t.parent;
  return Array.isArray(r) ? p.toArray() : p;
}
export {
  y as deepApplyTransform
};
//# sourceMappingURL=index4.js.map
